export default `
query cep($cep: String!) {
  cep(cep: $cep) {
    logradouro
    bairro
    cidade
    uf
  }
}
`;
